module.exports = __webpack_public_path__ + "static/img/14000012.74fcc9d9.png";